import { buildHead } from "@/lib/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/reset-password")({
  head: () =>
    buildHead({
      title: "Reset Password | LohaLink",
      description: "Set a new password for your LohaLink account.",
      canonical: "/reset-password",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/ResetPassword")),
});
